<template>
  <div>
    <form>
      <div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-5">
        <div class="p-field p-col-12 p-md-12">
          <span style="font-size: large">Salary Details</span>
          <Datatable :value="payHeadList">
            <Column header="PayHead" field=""/>
            <Column header="Amount" field="value">
            </Column>
            <template #empty>No record found</template>
          </Datatable>
        </div>
      </div>
      <hr/>
      <div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-5">
        <div class="p-field p-col-12 p-md-1">
          <Button class="p-button-raised" label="Save" icon="pi pi-save"/>
        </div>
      </div>
      <hr/>
      <span style="font-size: large">Bank Detail</span>
      <div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-5">
        <div class="p-field p-col-12 p-md-4">
          <label for="bankName">Bank Name</label>
          <InputText id="bankName" v-model="bankName"/>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label for="accountNumber">Account Number</label>
          <InputText id="accountNumber" v-model="accountNumber"/>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label for="branch">Branch</label>
          <InputText id="branch" v-model="branch"/>
        </div>
      </div>
      <div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-5">
        <div class="p-field p-col-12 p-md-1">
          <Button class="p-button-raised" label="Save" icon="pi pi-save"/>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Dropdown from 'primevue/dropdown'
import Datatable from 'primevue/datatable'
import Column from 'primevue/column'

export default {
  name: 'salary',
  data() {
    return {
      bankName: '',
      accountNumber: '',
      branch: '',
      filters: {},
      loading: false,
      editing: false,
      holidayId: null
    }
  },
  mounted() {
    this.findPayHead()
  },
  computed: {
    payHeadList() {
      return this.$store.state.hr.payHeadList
    }
  },
  methods: {
    async findPayHead() {
      await this.$store.dispatch('loadHrMasterSetupList')
    }
  },
  components: {
    Button,
    InputText,
    Dropdown,
    Datatable,
    Column
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// salary.vue?7ef99828